import type { ThemeTokens } from './types';

/** Shared non-color tokens used by all theme presets */
export const sharedTokens: Omit<ThemeTokens, 'colors'> = {
  radius: {
    base: '0.75rem',
  },
  typography: {
    fontFamily: {
      sans: [
        'Noto Sans JP',
        'Hiragino Sans',
        'Hiragino Kaku Gothic ProN',
        'Yu Gothic',
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'sans-serif',
      ],
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '0.9375rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
    },
    lineHeight: {
      tight: '1.35',
      normal: '1.55',
    },
    fontWeight: {
      medium: '500',
      semibold: '600',
    },
  },
  border: {
    width: '1px',
  },
  shadow: {
    notion:
      'rgba(12, 122, 58, 0.06) 0px 8px 32px, rgba(12, 122, 58, 0.04) 0px 0px 0px 1px',
    notionLg:
      'rgba(12, 122, 58, 0.10) 0px 12px 40px, rgba(12, 122, 58, 0.05) 0px 0px 0px 1px',
    toast: '0 8px 24px rgba(12, 122, 58, 0.10)',
  },
  ring: {
    width: '2px',
    offset: '2px',
  },
  transition: {
    duration: {
      fast: '150ms',
      normal: '200ms',
      slow: '300ms',
    },
  },
  scrollbar: {
    width: '8px',
    thumbRadius: '4px',
  },
  layout: {
    sidebarWidth: '15rem',
    sidebarCollapsedWidth: '4.25rem',
    headerHeight: '3.5rem',
    mobileHeaderHeight: '3.25rem',
    contentPadding: '0.75rem',
    mobileContentPadding: '0.5rem',
  },
};
